const pagesPersonAddPersonCertificationEn = {
  add: {
    intro: {
      header: {
        headerTitle: "Add Certification holder Data to your Registry",
      },
      body: {
        selectPersonAndCertification: "Select the person and certification: ",
        selectCertification: "Select the certification:",
        selectPerson: "Select the person:",
        selectPersonPlaceholder: "Select the person",
        fillOutDetails: "Fill out the details",
      },
      options: {
        description: "Or you might want to...",
        addCertification: "Add certification data",
      },
    },
    form: {
      progressbar: {
        total: "Total",
        mustItem: "Must Item",
        left: "{{value}} left",
        filled: "filled",
        modeSetting: "Mode Settings",
        mustItemOnly: "Must item only",
      },
      navigation: {
        title: "Add certification",
        steps: {
          common: {
            submitButtonLabel: "Add Certification Holder",
          },
          personBaseCertificationBasicInfo: {
            title: "Basic Info",
          },
          personBaseCertificationStatus: {
            title: "Certification Status",
          },
          personBaseCertificationIssueInfo: {
            title: "Issue Info",
          },
          personBaseCertificationEvidence: {
            title: "Evidence/Verification",
          },
          personBaseCertificationOperations: {
            title: "Operations Support",
          },
          personSpecialtyCertificationBasicInfo: {
            title: "Basic Info",
          },
          personSpecialtyCertificationStatus: {
            title: "Certification Status",
          },
          personSpecialtyCertificationCondition: {
            title: "Condition Information",
          },
          personSpecialtyCertificationEvidence: {
            title: "Evidence/Verification",
          },
          personSpecialtyCertificationOperations: {
            title: "Operations Support",
          },
          personHandlingCertificationBasicInfo: {
            title: "Basic Info",
          },
          personHandlingCertificationStatus: {
            title: "Certification Status",
          },
          personHandlingCertificationIssueApproval: {
            title: "Issue/Approval Information",
          },
          personHandlingCertificationCondition: {
            title: "Condition Information",
          },
          personHandlingCertificationEvidence: {
            title: "Evidence/Verification",
          },
          personHandlingCertificationOperations: {
            title: "Operations Support",
          },
        },
      },
      completed: {
        result: "Result",
        message: "Certification Holder added.",
        goToCertificationHolderData: "Go to certification holder data",
        completedBy: "Completed by:",
        continueAdding: "Continue adding another certification holder",
        goToList: "Go to list",
      },
      fields: {
        personBaseCertificationBasicInfo: {
          certificationHolder: {
            label: "Certification Holder",
          },
          baseCertification: {
            label: "Base Certification",
          },
          certificationNumber: {
            label: "Certification Number",
            placeholder: "Enter certification number",
          },
          acquisitionType: {
            label: "Acquisition Type",
            placeholder: "Enter acquisition type",
          },
          firstAcquiredDate: {
            label: "First Acquired Date",
            placeholder: "Select first acquired date",
          },
          lastRenewalDate: {
            label: "Last Renewal Date",
            placeholder: "Select last renewal date",
          },
          validTo: {
            label: "Valid To",
            placeholder: "Select valid to date",
          },
          renewalDeadline: {
            label: "Renewal Deadline",
            placeholder: "Select renewal deadline",
          },
        },
        personBaseCertificationStatus: {
          certificationStatus: {
            label: "Certification Status",
            placeholder: "Select certification status",
          },
          certificationStatusChangeDate: {
            label: "Certification Status Change Date",
            placeholder: "Select certification status change date",
          },
          certificationStatusReason: {
            label: "Certification Status Reason",
            placeholder: "Enter certification status reason",
          },
        },
        personBaseCertificationIssueInfo: {
          issuingOrganizationId: {
            label: "Issuing Organization ID",
            placeholder: "Enter issuing organization ID",
          },
          issueDate: {
            label: "Issue Date",
            placeholder: "Select issue date",
          },
          issuePlace: {
            label: "Issue Place",
            placeholder: "Enter issue place",
          },
        },
        personBaseCertificationEvidence: {
          certificateFilePath: {
            label: "Certificate File Path",
            placeholder: "Enter certificate file path",
          },
          originalVerificationDate: {
            label: "Original Verification Date",
            placeholder: "Select original verification date",
          },
          originalVerifier: {
            label: "Original Verifier",
            placeholder: "Enter original verifier",
          },
          verificationMethod: {
            label: "Verification Method",
            placeholder: "Enter verification method",
          },
          lastVerifiedDate: {
            label: "Last Verified Date",
            placeholder: "Select last verified date",
          },
        },
        personBaseCertificationOperations: {
          managementType: {
            label: "Management Type",
            placeholder: "Enter management type",
          },
          criticalCertificationFlag: {
            label: "Critical Certification Flag",
            checkboxLabel: "This is a critical certification",
          },
          remarks: {
            label: "Remarks",
            placeholder: "Enter remarks",
          },
        },
        personSpecialtyCertificationBasicInfo: {
          certificationHolder: {
            label: "Certification Holder",
          },
          specialtyCertification: {
            label: "Specialty Certification",
          },
          baseCertificationId: {
            label: "Base Certification ID",
            placeholder: "Enter base certification ID",
          },
          certificationNumber: {
            label: "Certification Number",
            placeholder: "Enter certification number",
          },
          acquisitionType: {
            label: "Acquisition Type",
            placeholder: "Enter acquisition type",
          },
          firstAcquiredDate: {
            label: "First Acquired Date",
            placeholder: "Select first acquired date",
          },
          lastRenewalDate: {
            label: "Last Renewal Date",
            placeholder: "Select last renewal date",
          },
          validTo: {
            label: "Valid To",
            placeholder: "Select valid to date",
          },
          renewalDeadline: {
            label: "Renewal Deadline",
            placeholder: "Select renewal deadline",
          },
          personBaseCertificationRecordIds: {
            label: "Base Certification Records",
            add: "Add Related Base Certification Record",
          },
        },
        personSpecialtyCertificationStatus: {
          certificationStatus: {
            label: "Certification Status",
            placeholder: "Select certification status",
          },
          certificationStatusChangeDate: {
            label: "Certification Status Change Date",
            placeholder: "Select certification status change date",
          },
          certificationStatusReason: {
            label: "Certification Status Reason",
            placeholder: "Enter certification status reason",
          },
        },
        personSpecialtyCertificationCondition: {
          experienceYearsAtAcquisition: {
            label: "Experience Years at Acquisition",
            placeholder: "Enter experience years at acquisition",
          },
          caseCountAtAcquisition: {
            label: "Case Count at Acquisition",
            placeholder: "Enter case count at acquisition",
          },
        },
        personSpecialtyCertificationEvidence: {
          certificateFilePath: {
            label: "Certificate File Path",
            placeholder: "Enter certificate file path",
          },
          originalVerifiedDate: {
            label: "Original Verified Date",
            placeholder: "Select original verified date",
          },
          originalVerifier: {
            label: "Original Verifier",
            placeholder: "Enter original verifier",
          },
          lastVerifiedDate: {
            label: "Last Verified Date",
            placeholder: "Select last verified date",
          },
        },
        personSpecialtyCertificationOperations: {
          primarySpecialtyFlag: {
            label: "Primary Specialty Flag",
            checkboxLabel: "This is a primary specialty",
          },
          remarks: {
            label: "Remarks",
            placeholder: "Enter remarks",
          },
        },
        personHandlingCertificationBasicInfo: {
          certificationHolder: {
            label: "Certification Holder",
          },
          handlingCertification: {
            label: "Handling Certification",
          },
          handlingStartDate: {
            label: "Handling Start Date",
            placeholder: "Select handling start date",
          },
          handlingEndDate: {
            label: "Handling End Date",
            placeholder: "Select handling end date",
          },
          lastRenewalDate: {
            label: "Last Renewal Date",
            placeholder: "Select last renewal date",
          },
          validTo: {
            label: "Valid To",
            placeholder: "Select valid to date",
          },
          renewalDeadline: {
            label: "Renewal Deadline",
            placeholder: "Select renewal deadline",
          },
          personBaseCertificationRecordIds: {
            label: "Base Certification Records",
            add: "Add Related Base Certification Record",
          },
          personSpecialtyCertificationRecordIds: {
            label: "Specialty Certification Records",
            add: "Add Related Specialty Certification Record",
          },
        },
        personHandlingCertificationStatus: {
          certificationStatus: {
            label: "Certification Status",
            placeholder: "Select certification status",
          },
          certificationStatusChangeDate: {
            label: "Certification Status Change Date",
            placeholder: "Select certification status change date",
          },
          certificationStatusReason: {
            label: "Certification Status Reason",
            placeholder: "Enter certification status reason",
          },
        },
        personHandlingCertificationIssueApproval: {
          issuingOrganizationId: {
            label: "Issuing Organization ID",
            placeholder: "Enter issuing organization ID",
          },
          internalApprover: {
            label: "Internal Approver",
            placeholder: "Enter internal approver",
          },
          approvedDate: {
            label: "Approved Date",
            placeholder: "Select approved date",
          },
        },
        personHandlingCertificationCondition: {
          trainingId: {
            label: "Training ID",
            placeholder: "Enter training ID",
          },
          examId: {
            label: "Exam ID",
            placeholder: "Enter exam ID",
          },
          handlingRestrictionCondition: {
            label: "Handling Restriction Condition",
            placeholder: "Enter handling restriction condition",
          },
          channel: {
            label: "Channel",
            placeholder: "Enter channel",
          },
          place: {
            label: "Place",
            placeholder: "Enter place",
          },
        },
        personHandlingCertificationEvidence: {
          certificateFilePath: {
            label: "Certificate File Path",
            placeholder: "Enter certificate file path",
          },
          lastVerifiedDate: {
            label: "Last Verified Date",
            placeholder: "Select last verified date",
          },
        },
        personHandlingCertificationOperations: {
          priority: {
            label: "Priority",
            placeholder: "Enter priority",
          },
          remarks: {
            label: "Remarks",
            placeholder: "Enter remarks",
          },
        },
      },
    },
  },
  list: {
    pageTitle: "Certifications",
    addCertification: "Add Certification",
    filterPlaceholder: "Search by certification name...",
    tabs: {
      national: "National",
      public: "Public",
      private: "Private",
      all: "All",
    },
    actions: {
      export: "Export",
      share: "Share",
    },
  },
  certificationKind: {
    base: "Base certification",
    specialty: "Specialty certification",
    handling: "Handling certification",
  },
  detail: {
    tabs: {
      detail: "Detail",
      specialtyCertifications: "Specialty certifications",
      handlingCertifications: "Handling certifications",
    },
    body: {
      noDataMessage: "No data available in this section.",
      errors: {
        dataLoadFailed: "Failed to load data",
        unknownError: "An unknown error occurred",
        certificationNotFound: "Certification details not found",
        certificationIdLabel: "Certification ID: {{id}}",
      },
    },
  },
  certificationStatus: {
    EFFECTIVE: "Effective",
    NOT_EFFECTIVE: "Not Effective",
    ARCHIVED: "Archived",
  },
  specialty: {
    list: {
      pageTitle: "Specialty Certifications",
      filterPlaceholder: "Search by specialty certification name...",
      addSpecialtyCertification: "Add Specialty Certification",
      tabs: {
        effective: "Effective",
        notEffective: "Not Effective",
        archived: "Archived",
      },
    },
    detail: {
      tabs: {
        detail: "Detail",
      },
      body: {
        noDataMessage: "No data available in this section.",
        errors: {
          dataLoadFailed: "Failed to load data",
          unknownError: "An unknown error occurred",
          specialtyCertificationNotFound:
            "Specialty certification details not found",
          specialtyCertificationIdLabel: "Specialty Certification ID: {{id}}",
        },
      },
    },
  },
  handling: {
    list: {
      pageTitle: "Handling Certifications",
      filterPlaceholder: "Search by handling certification name...",
      addHandlingCertification: "Add Handling Certification",
      tabs: {
        effective: "Effective",
        notEffective: "Not Effective",
        archived: "Archived",
      },
    },
    detail: {
      tabs: {
        detail: "Detail",
      },
      body: {
        noDataMessage: "No data available in this section.",
        errors: {
          dataLoadFailed: "Failed to load data",
          unknownError: "An unknown error occurred",
          handlingCertificationNotFound:
            "Handling certification details not found",
          handlingCertificationIdLabel: "Handling Certification ID: {{id}}",
        },
      },
    },
  },
};

export default pagesPersonAddPersonCertificationEn;
